import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/user', parameters);
    }

    async lock(params = null) {
        return this.submit('put', '/lock', params);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/User.js